// extracted by mini-css-extract-plugin
module.exports = {"container":"_1BSD_pJSpyZMK3okUlpufH"};